<template>
    <div class="resource_card">
        <div class="card_inner_wrap">
            <a :href="model.url" v-on:click.prevent="onClick" class="card_image_link" :class="{type_video: typeClass === 'videos'}">
                <img :src="thumbnailUrl" class="card_image" lazy :data-static="thumbnailStaticUrl" :alt="titleText"
                    onerror="this.src=this.dataset.static" />
            </a>
            <div v-if="resourceTags && resourceTags.length > 0" class="card_tags">
                <a v-for="(item,index) of resourceTags" :key="index" :href="item.link" class="cart_tag_item">{{ item.text }}</a>
            </div>
            <div class="card_text">
                <h3 class="card_mc_title"><a :href="model.url" v-on:click.prevent="onClick">{{titleText}}</a></h3>
                
                <a :href="authorUrl" v-if="authorUrl"><i class="card_mc_author">Author: {{author}}</i></a>
                <i class="card_mc_author" v-else-if="author">Author: {{author}}</i>

                <div class="card_mc_intro">
                    {{ summary }}
                </div>
                <a :href="model.url" class="read_more" v-on:click.prevent="onClick">{{ readMoreLabel }}</a>
            </div>
        </div>
    </div>
</template>

<script>
    import { StringUtils } from "../../functions/string-utils";
    import cardMixin from "../../mixins/card-mixin";

    export default {
        name: "Resource",
        mixins: [cardMixin],
        props: {
            model: {
                type: Object,
                default: {}
            }
        },
        computed: {
            summary: function () {
                var summaryText = this.model.shortDescription ? this.model.shortDescription : this.customDict.summary;
                return StringUtils.summarizeText(summaryText);
            },
            author: function () {
                var authorText = this.model.author ? this.model.author : this.customDict.author;
                return authorText ? authorText : '';
            },
            authorUrl: function () {
                var authorUrl = this.model.authorUrl ? this.model.authorUrl : this.customDict.authorUrl;
                return authorUrl ? authorUrl : '';
            },
            readMoreLabel: function () {
                switch (this.typeClass) {
                    case 'videos': return 'Watch Now'
                    case 'podcasts': return 'Listen Now'
                    default: return 'Read more'
                }
            },
            typeClass: function () {
                const resourceType = this.model.resourcetype;
                if (typeof resourceType === "string")
                    return resourceType.toLowerCase();

                return "";
            },
            resourceTags: function () {
                var thisTags = this.customDict.tags,
                    resCenterUrl = GlobalApp.generalSettings.resourceCenterPageUrl;

                if (typeof thisTags === "string") {
                    return [
                        {
                            text: thisTags,
                            link: `${resCenterUrl}?refinementList%5Btags%5D%5B0%5D=${encodeURI(thisTags)}`
                        }
                    ]
                } else if (Array.isArray(thisTags)) {
                    var arr = [];
                    thisTags.map((el) => {
                        arr.push(
                            {
                                text: el,
                                link: `${resCenterUrl}?refinementList%5Btags%5D%5B0%5D=${encodeURI(el)}`
                            }
                        )
                    })
                    return arr;
                }

                return [];
            },
            titleText: function () {
                if (this.model.itemName) return this.model.itemName;
                else if (this.customDict.title) {
                    return this.customDict.title;
                }
                return ''
            },
        },
        methods: {
            onClick: function (e) {
                this.$emit('clicked', e);
            }
        }
    };
</script>